// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\n.drag-ghost[data-v-482f5986] {\n  opacity: 0.5;\n  background: #f0f0f0;\n}\n.switch-no-details[data-v-482f5986]  .v-messages {\n  min-height: 0;\n}", ""]);
// Exports
module.exports = exports;
